module.exports = __webpack_public_path__ + "img/二维码s.b65d4f3b.png";